// 全局自动弹窗共用展示位；关闭动画后保留1.2秒间隔，不更改业务状态或已读记录。
export function createPopupGate(now:()=>number=()=>Date.now(),gap=1200){
  let owner:object|undefined,notBefore=0
  const suspended=new Set<{owner?:object}>()
  return {
    available(who?:object){return owner ? owner===who : now()>=notBefore},
    acquire(who:object){if(owner)return owner===who;if(now()<notBefore)return false;owner=who;return true},
    release(who:object){suspended.forEach(frame=>{if(frame.owner===who)frame.owner=undefined});if(owner!==who)return;owner=undefined;notBefore=now()+gap},
    // 仅错误提示借用展示位；保留父窗口持有者，不执行确认或已读业务。
    interrupt(who:object){if(!owner || owner===who)return;const frame={owner} as {owner?:object};suspended.add(frame);owner=who;return()=>{if(!suspended.delete(frame))return;if(owner && owner!==who)return;owner=frame.owner}}
  }
}
export const popupGate=createPopupGate()
